import { render, staticRenderFns } from "./paymentLink.vue?vue&type=template&id=6b5357e0"
import script from "./paymentLink.vue?vue&type=script&lang=js"
export * from "./paymentLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports